import { __decorate } from "tslib";
import _ from 'lodash';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core/common/event';
/**
 * Represents a service that provides selection management.
 */
export const SelectionManager = Symbol('SelectionManager');
let AbstractSelectionManager = class AbstractSelectionManager {
    constructor() {
        this.selection = new Set();
        this._emitter = new Emitter();
        this.onChange = this._emitter.event;
    }
    select(element) {
        this.selection.add(element);
        this.notifySelectionChange();
    }
    deselect(element) {
        const id = this.identify(element);
        const elementInSelection = Array.from(this.selection).find((item) => {
            return this.identify(item) === id;
        });
        if (elementInSelection) {
            this.selection.delete(elementInSelection);
        }
        this.notifySelectionChange();
    }
    clearSelection() {
        this.selection.clear();
        this.notifySelectionChange();
    }
    getSelection() {
        return this.selection;
    }
    getSelectionSize() {
        return this.selection.size;
    }
    getArraySelection() {
        return Array.from(this.getSelection()).map((item) => {
            return this.identify(item);
        });
    }
    without(elements) {
        const ids = elements.map(this.identify);
        const array = Array.from(this.selection).filter((item) => {
            return !ids.includes(this.identify(item));
        });
        this.selection = new Set(array);
        this.notifySelectionChange();
    }
    union(elements) {
        const array = _.unionBy(Array.from(this.selection), elements, this.identify);
        this.selection = new Set(array);
        this.notifySelectionChange();
    }
    notifySelectionChange() {
        this._emitter.fire({
            ids: this.getArraySelection(),
            selection: this.selection,
        });
    }
};
AbstractSelectionManager = __decorate([
    injectable()
], AbstractSelectionManager);
export { AbstractSelectionManager };
